import React from 'react';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
  padding?: 'sm' | 'md' | 'lg' | 'none';
}

const Card: React.FC<CardProps> = ({ 
  children, 
  className = '', 
  padding = 'md',
  onClick,
  ...rest
}) => {
  const paddingClasses = {
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
    none: '',
  };

  return (
    <div
      className={`bg-white dark:bg-gray-900 rounded-xl shadow-sm ring-1 ring-gray-200 dark:ring-gray-800 overflow-hidden min-w-0 ${paddingClasses[padding]} ${className} ${onClick ? 'cursor-pointer transition duration-200 hover:shadow-md hover:-translate-y-0.5' : ''}`}
      onClick={onClick}
      {...rest}
    >
      {children}
    </div>
  );
};

export default Card; 